import styled from "styled-components";
import { rem } from "@ui/helpers";

const EndOfTenancySidebarContainer = styled.div`
  position: sticky;
  top: ${props => props.theme.margins.base_x4};

  ${props => props.theme.breakpoints.desktop} {
    margin-bottom: ${props => props.theme.margins.base_x2};
  }
`;

const EndOfTenancySummaryList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  flex: 1;

  li {
    margin: 0;
    padding: 0;
  }

  svg {
    margin-right: ${props => props.theme.margins.base_x2};
    position: relative;
    top: -${rem(1)};
  }

  ${props => props.theme.breakpoints.desktop} {
    width: 100%;

    li {
      padding: ${props => props.theme.margins.base} 0;
    }
  }
`;

const EndOfTenancyTopQuestionsList = styled.div`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: ${props => props.theme.fonts.sizes.body2};

    li {
      margin-bottom: ${props => props.theme.margins.half};

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
`;

const CleaningType = styled.li`
  font-weight: ${props => props.theme.fonts.weights.bold};
`;

export {
  EndOfTenancySidebarContainer,
  EndOfTenancySummaryList,
  EndOfTenancyTopQuestionsList,
  CleaningType,
};
